/**
 * Shared types for playbook editor components
 */

import type { Drawing } from '@/types/Drawing.types'

export type Play = {
	id: string
	name: string
	formation: string
	playType: string
	defensiveFormation: string
	labels: string[]
	labelObjects?: { id: string; name: string; color: string }[]
	lastModified: string
	thumbnail?: string
	drawings?: Drawing[]
	personnel?: string
}

/** Grouping container used by the export system */
export type ExportSection = {
	id: string
	name: string
	plays: Play[]
}

export type ConceptType = 'concept' | 'formation'

export type EditorTab = 'plays' | 'formations' | 'routes' | 'blocking' | 'motion' | 'protection' | 'modifiers'

export const EDITOR_TAB_OPTIONS: Array<{ value: EditorTab; label: string }> = [
	{ value: 'plays', label: 'Plays' },
	{ value: 'formations', label: 'Formations' },
	{ value: 'routes', label: 'Routes' },
	{ value: 'blocking', label: 'Run Schemes' },
	{ value: 'motion', label: 'Motions' },
	{ value: 'protection', label: 'Protections' },
	{ value: 'modifiers', label: 'Modifiers' },
]
